import axios from 'src/utils/axios';
import { getBaseUrl } from 'src/utils/get-api-url';

const baseUrl = getBaseUrl();

/**
 * Get token after first auth.
 * @param {string} idToken - token generated from Global Auth.
 * @param {string} challenge - code_challenge generated by application.
 * @returns {Promise<Object>}
 */
export function getToken(idToken = '', challenge = ''){
    return axios.get(`${baseUrl}auth`, {
        headers: {
            globalAuthToken: idToken,
        },
        params: {
            code_challenge: challenge,
        }
    });
};

//TODO - update after new auth with mock_login
export function getMockToken(email = '') {
    return axios.get(`${baseUrl}auth`, {
        headers: {
            email: email,
        },
        params: {
            code_challenge: 'w5bCmUfCil7Cr3p5FVEiw7ocwqQOwqzCosKYUMOGDGLCocOgwrEiw47CmsKUAR7Cmg',
        }
    });
};

/**
 * Get data from logged user.
 * @returns {Promise<Object>}
 */
export function getLoggedUser() {
    return axios.get(`${baseUrl}loggedUser`);
};

/**
 * Get new refresh token after expiration.
 * @returns {Promise<Object>}
 */
export function refreshToken() {
    return axios.post(`${baseUrl}auth/refresh`);
}

/**
 * Logout from application. API revokes access and refresh tokens and Front-end removes code-verifier.
 * @returns {Promise<Object>}
 */
export function logout() {
    return axios.post(`${baseUrl}logout`);
}
